import React from 'react'
import type { ReactNode } from 'react'
import type { RouteDef } from '@ztechapps/common.contract'
import { Link } from '@ztechapps/webui.util'
import { parsePivotLinkLabel } from './parsePivotLinkLabel'

/**
 * Renders a pivot cell whose label is a `<code>|<_id>` pair as a link to the entity's detail
 * page. `reversed` names the case where the wire sends `<_id>|<code>` instead (e.g. the serial
 * number report's consumed-work-order label from InventoryBySerialNumberPivotReport).
 */
export const renderPivotLinkCell = (label: string, route: RouteDef, reversed = false): ReactNode => {
  const parsed = parsePivotLinkLabel(label, reversed)
  if (!parsed) return undefined
  return (
    <Link
      href={route.altPath({ _id: parsed._id })}
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-underline"
    >
      {parsed.code}
    </Link>
  )
}
